import { changeReasons, fakeChecklist } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function AddressChange() {
  return (
    <section id="entry-address" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/60">
      <Reveal>
        <SectionHeading
          tag="地址变化"
          title="最新地址为什么会变？变化期最要小心什么"
          desc="地址变化本身是常见现象，真正需要提防的是变化期间冒出来的仿冒页面。弄清楚原因，再学会判断真假，就能稳稳找到入口。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {changeReasons.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 60}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="lg:col-span-5" delay={120}>
          <div className="h-full rounded-lg border border-accent-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-shield-check-line text-lg"></i>
              </span>
              <h3 className="font-heading font-bold text-foreground-950 text-lg">真假站点判断清单</h3>
            </div>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              进入任何页面之前，用下面几条快速过一遍，多数风险都能提前避开。
            </p>
            <ul className="mt-5 space-y-3.5">
              {fakeChecklist.map((text, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-xs font-label shrink-0 mt-0.5">
                    {idx + 1}
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}